
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'office-ui-fabric-react/lib/Link';

import infoGetActions from '../../sagas/info';

const LinkToTeleso = (props) => {

    const dispatch = useDispatch();
    const infoActions = infoGetActions(dispatch);

    const token = useSelector(state => {
        return state.auth.data ? state.auth.data.user.token : null;
    });

    const projectId = useSelector(state => {
        return state.project.data.project.id;
    });

    const handleClick = () => {
        infoActions.getObjectTeleso(token, projectId, props.tel.id);
    }

    return (
        <Link onClick={handleClick} title="Zobrazit informace o listu vlastnictví">{props.tel.cislo_tel}</Link>
    )
}

export default LinkToTeleso;
